import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const HomeIcon = (props: SvgIconProps) => {
    const fill = props.fill ?? 'none';
    return (
        <SvgIcon viewBox="0 0 24 24" {...props} fill={fill} sx={{ ...props.sx, fill }}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.4063 8.50485L13.7397 4.09712C12.7168 3.30096 11.2841 3.30096 10.2603 4.09712L4.59367 8.50485C3.90328 9.04129 3.5 9.86674 3.5 10.7413V17.6669C3.5 19.2318 4.76839 20.5002 6.33333 20.5002H17.6667C19.2316 20.5002 20.5 19.2318 20.5 17.6669V10.7413C20.5 9.86674 20.0967 9.04129 19.4063 8.50485Z"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M9.16699 16.7222H14.8337"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

export default HomeIcon;
